/* eslint-disable */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) {
            t[p] = s[p];
        }
    }
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) {
                t[p[i]] = s[p[i]];
            }
        }
    }
    return t;
};
import { TRACK_TYPES } from './constants';
var MatomoTracker = function MatomoTracker(userOptions) {
    var _this = this;

    if (!userOptions.urlBase) {
        throw new Error('Matomo urlBase is required.');
    }
    if (!userOptions.siteId) {
        throw new Error('Matomo siteId is required.');
    }

    this.pushInstruction = function(name) {
        var args = Array.prototype.slice.call(arguments, 1);
        if (typeof window !== 'undefined') {
            // eslint-disable-next-line
            window._paq.push([name].concat(args));
        }
        return _this;
    }

    this.enableHeartBeatTimer = function (seconds) {
        _this.pushInstruction('enableHeartBeatTimer', seconds);
    };

    this.enableLinkTracking = function (active) {
        _this.pushInstruction('enableLinkTracking', active);
    };

    this.initialize = function(options) {
        var urlBase = options.urlBase,
            siteId = options.siteId,
            userId = options.userId,
            trackerUrl = options.trackerUrl,
            srcUrl = options.srcUrl,
            disabled = options.disabled,
            heartBeat = options.heartBeat,
            linkTracking = options.linkTracking,
            configurations = options.configurations || {};
        var normalizedUrlBase = urlBase[urlBase.length - 1] !== '/' ? urlBase + '/' : urlBase;
        if (typeof window === 'undefined') {
            return;
        }
        window._paq = window._paq || [];
        if (window._paq.length !== 0) {
            return;
        }
        if (disabled) {
            return;
        }
        _this.pushInstruction('setTrackerUrl', trackerUrl !== null && trackerUrl !== undefined ? trackerUrl : normalizedUrlBase + 'matomo.php');
        _this.pushInstruction('setSiteId', siteId);
        if (userId) {
            _this.pushInstruction('setUserId', userId);
        }
        Object.entries(configurations).forEach(function(_ref) {
            var name = _ref[0],
                instructions = _ref[1];
            if (instructions instanceof Array) {
                _this.pushInstruction.apply(_this, [name].concat(instructions));
            } else {
                _this.pushInstruction(name, instructions);
            }
        });
        if (!heartBeat || heartBeat && heartBeat.active) {
            _this.enableHeartBeatTimer(heartBeat && heartBeat.seconds !== undefined ? heartBeat.seconds : 15);
        }
        _this.enableLinkTracking(linkTracking);
        var doc = document;
        var scriptElement = doc.createElement('script');
        var scripts = doc.getElementsByTagName('script')[0];
        scriptElement.type = 'text/javascript';
        scriptElement.async = true;
        scriptElement.defer = true;
        scriptElement.src = srcUrl || normalizedUrlBase + 'matomo.js';
        if (scripts && scripts.parentNode) {
            scripts.parentNode.insertBefore(scriptElement, scripts);
        }
    };
    
    this.trackEventsForElements = function (elements) {
        if (elements.length) {
            elements.forEach(function (element) {
                element.addEventListener('click', function () {
                    var matomoCategory = element.dataset.matomoCategory;
                    var matomoAction = element.dataset.matomoAction;
                    var matomoName = element.dataset.matomoName;
                    var matomoValue = element.dataset.matomoValue;

                    if (matomoCategory && matomoAction) {
                        _this.trackEvent({
                            category: matomoCategory,
                            action: matomoAction,
                            name: matomoName,
                            value: Number(matomoValue)
                        });
                    } else {
                        throw new Error('Error: data-matomo-category and data-matomo-action are required.');
                    }
                });
            });
        }
    };

    this.trackEvents = function () {
        var matchString = '[data-matomo-event="click"]';
        var firstTime = false;

        if (!_this.mutationObserver) {
            firstTime = true;

            _this.mutationObserver = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    mutation.addedNodes.forEach(function (node) {
                        if (!(node instanceof HTMLElement)) {
                            return;
                        }
                        if (node.matches(matchString)) {
                            _this.trackEventsForElements([node]);
                        }
                        var elements = Array.from(node.querySelectorAll(matchString));
                        _this.trackEventsForElements(elements);
                    });
                });
            });
        }
        _this.mutationObserver.observe(document, {
            childList: true,
            subtree: true
        });

        if (firstTime) {
            var elements = Array.from(document.querySelectorAll(matchString));
            _this.trackEventsForElements(elements);
        }
    };

    this.stopObserving = function () {
        if (_this.mutationObserver) {
            _this.mutationObserver.disconnect();
        }
    };
    this.trackEvent = function(_a) {
        var category = _a.category, action = _a.action, name = _a.name, value = _a.value, otherParams = (_a, ["category", "action", "name", "value"]);
        if (category && action) {
            _this.track(Object.assign({ data: ['TRACK_EVENT', category, action, name, value] }, otherParams));
        }
        else {
            throw new Error('Error: category and action are required.');
        }
    };
    
    this.trackSiteSearch = function(_a) {
        var keyword = _a.keyword, category = _a.category, count = _a.count, otherParams = (_a, ["keyword", "category", "count"]);
        if (keyword) {
            _this.track(Object.assign({ data: ['TRACK_SEARCH', keyword, category, count] }, otherParams));
        }
        else {
            throw new Error('Error: keyword is required.');
        }
    };
    
    this.trackLink = function(_a) {
        var href = _a.href, linkType = _a.linkType || 'link';
        _this.pushInstruction('TRACK_LINK', href, linkType);
    };
    
    this.trackPageView = function(params) {
        _this.track(Object.assign({ data: ['trackPageView'] }, params));
    };
    
    this.addEcommerceItem = function(_a) {
        var sku = _a.sku, productName = _a.productName, productCategory = _a.productCategory, productPrice = _a.productPrice || 0.0, productQuantity = _a.productQuantity || 1;
        _this.pushInstruction('addEcommerceItem', sku, productName, productCategory, productPrice, productQuantity);
    };
    
    this.removeEcommerceItem = function(_a) {
        var sku = _a.sku;
        _this.pushInstruction('removeEcommerceItem', sku);
    };
    
    this.clearEcommerceCart = function() {
        _this.pushInstruction('clearEcommerceCart');
    };
    
    this.trackEcommerceOrder = function(_a) {
        var orderId = _a.orderId, orderRevenue = _a.orderRevenue, orderSubTotal = _a.orderSubTotal, taxAmount = _a.taxAmount, shippingAmount = _a.shippingAmount, discountOffered = _a.discountOffered || false;
        _this.track({
            data: [
                'TRACK_ECOMMERCE_ORDER',
                orderId,
                orderRevenue,
                orderSubTotal,
                taxAmount,
                shippingAmount,
                discountOffered,
            ],
        });
    };
    
    this.trackEcommerceCartUpdate = function(amount) {
        _this.pushInstruction('TRACK_ECOMMERCE_CART_UPDATE', amount);
    };
    
    this.setEcommerceView = function(_a) {
        var sku = _a.sku, productName = _a.productName, productCategory = _a.productCategory, productPrice = _a.productPrice;
        _this.pushInstruction('setEcommerceView', sku, productName, productCategory, productPrice);
    };
    
    this.setEcommerceCategoryView = function(productCategory) {
        _this.setEcommerceView({ productCategory: productCategory, productName: false, sku: false });
    };
    this.track = function(_a) {
        var _a$data = _a.data,
            data = _a$data === void 0 ? [] : _a$data,
            _a$documentTitle = _a.documentTitle,
            documentTitle = _a$documentTitle === void 0 ? window.document.title : _a$documentTitle,
            href = _a.href,
            _a$customDimensions = _a.customDimensions,
            customDimensions = _a$customDimensions === void 0 ? false : _a$customDimensions;
        if (data.length) {
            if (customDimensions && Array.isArray(customDimensions) && customDimensions.length) {
                customDimensions.map(function (customDimension) {
                    return _this.pushInstruction('setCustomDimension', customDimension.id, customDimension.value);
                });
            }
            _this.pushInstruction('setCustomUrl', href !== null && href !== void 0 ? href : window.location.href);
            _this.pushInstruction('setDocumentTitle', documentTitle);
            _this.pushInstruction.apply(_this, data);
        }
    };

    this.initialize(userOptions);
}
export default MatomoTracker;
//# sourceMappingURL=MatomoTracker.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@datapunt/matomo-tracker-js/es/MatomoTracker.js
// module id = 769
// module chunks = 0